import { render, staticRenderFns } from "./DrugRequestForm.vue?vue&type=template&id=83d8ecd6&scoped=true"
import script from "./DrugRequestForm.vue?vue&type=script&lang=js"
export * from "./DrugRequestForm.vue?vue&type=script&lang=js"
import style0 from "./DrugRequestForm.vue?vue&type=style&index=0&id=83d8ecd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d8ecd6",
  null
  
)

export default component.exports